export const defaultStyle = {
    heading: "headline4",
    wrapper: "ingredients-box w-full bg-white shrink-0 p-[24px] mb-[48px] lg:mb-0 lg:max-w-[367px] xlg:max-w-[414px]",
    block: "border-t-[1px] py-[24px] mt-[24px] lg:py-[32px] lg:mt-[32px] border-black",
    item: "flex py-[16px] items-baseline space-x-[16px] border-y-[1px] border-dashed first:border-none first:pt-0 last:border-none last:pb-0 body-m font-normal",
    itemIconWrapper: "w-[13px] h-[13px] flex items-center justify-center",
}
